<template>
  <div>
    <div class="content-box">
      <p class="p1">
        {{ dataInfo.title }}
      </p>
      <div v-loading="loading" v-html="dataInfo.content"></div>
      <!-- <p class="p1">{{$t('footerPrivacy.title')}}</p>
      <p class="p2 mt16">{{$t('footerPrivacy.title')}}</p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo')}}</p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo1')}}</p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo2')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo3')}}
        <p class="p2">{{$t('footerPrivacy.titleInfo4')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo5')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo6')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo7')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo8')}}</p>
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo9')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo10')}}
        <p class="p2">{{$t('footerPrivacy.titleInfo11')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo12')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo13')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo14')}}</p>
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo15')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo16')}}
        <p class="p2">{{$t('footerPrivacy.titleInfo17')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo18')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo19')}}</p>
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo20')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo21')}}
        <p class="p2">{{$t('footerPrivacy.titleInfo22')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo23')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo24')}}</p>
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo25')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo26')}}
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo27')}}</p>
      <p class="p2 mt16">
       {{$t('footerPrivacy.titleInfo28')}}
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo29')}}</p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo30')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo31')}}
        <p class="p2">{{$t('footerPrivacy.titleInfo32')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo33')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo34')}}</p>
        <p class="p2">{{$t('footerPrivacy.titleInfo35')}}</p>
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo36')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo37')}}
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo38')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo39')}}
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo40')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo41')}}
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo42')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo43')}}
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo44')}}</p>
      <p class="p2 mt16">
        {{$t('footerPrivacy.titleInfo45')}}
      </p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo46')}}</p>
      <p class="p2 mt16">{{$t('footerPrivacy.titleInfo47')}}</p> -->
    </div>
    <VFooter />
  </div>
</template>

<script>
import { mapState } from "vuex";
import VFooter from "@/components/footer/VFooter";
export default {
  name: "download",
  components: {
    VFooter,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
		loading: false,
      dataInfo: {
        title: '',
        content: ''
      },
    }
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      const _this = this;
	  this.loading = true;
      this.$axios.post("/cms/getList", {
        page: 1,
        rows: 1,
        cateCode: "privacy-policy",
      }).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.dataInfo = res.data.data.rows[0] || {};
        }
      }).finally(()=>{
		  this.loading = false;
	  });
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  position: relative;
  padding: 120px 260px;
  background-color: #f5f6f7;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(~@/assets/img/images/footer-download.png);
  .mt16 {
    margin-top: 16px;
  }
  .mt60 {
    margin-top: 60px;
  }
  .p1 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 36px;
    color: #333333;
    margin-bottom: 60px;
  }
  .p2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f2329;
  }
}
</style>
